import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import EditWrap from "../commonComponent/editWrap";
import { Autocomplete, Button, Checkbox, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Toolbar, Tooltip, Typography } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { toast } from "react-toastify";
import moment from "moment";
import { notifiy } from "../notification/Notification";
import { calFrequencyOptions, ConOfDucdOptions, locationOptions } from "../../constants/srfConstants";
import { fetchAddresses } from "../invoice/productDetails";
import { ClassicTable } from "../../utils/components/Styles";

export const orderStatusOption = [
  { id: 1, label: "NTBC" },
  { id: 2, label: "C" },
  { id: 3, label: "C-L" },
];

export const calTypeOption = [
  { id: 1, label: "NABL" },
  { id: 3, label: "NON NABL" },
];

export const orserTYpeArray = [
  { id: "C", label: "C" },
  { id: "NEW", label: "NEW" },
  { id: "RC", label: "RC" },
  { id: "SER", label: "SER" },
];

// export const partyArray = [
//   { id: "CC", label: "CC" },
//   { id: "SS", label: "SS" },
//   { id: "UC", label: "UC" },
//   { id: "Direct", label: "Direct" },
//   { id: "VISC", label: "VISC" },
//   { id: "MCI", label: "MCI" },
// ];
export const teamMemberArray = [
  {id : "T1", label : "T1"},
  {id : "T2", label : "T2"},
  {id : "T3", label : "T3"},  
];

// Build the display label used both for showing and saving
const getDUCLabel = (inst) =>
  `${inst.instrumentName || ""}${inst.DUCID ? ` - DUCID(${inst.DUCID})` : ""}${
    inst.certificateNumber
      ? ` - Certificate No (${inst.certificateNumber})`
      : ""
  }`;

// Small helper to give each not-yet-saved DUC row a stable client-side key
const makeTempId = () =>`new-${Date.now()}-${Math.random().toString(36).slice(2)}`;

const EditindependentSrf = () => {
  const params = useParams();
  const navigate = useNavigate();
  const isEdit = params?.id && params.id !== "0";

  const [inputStates, setInputStates] = useState({});
  const [clientArray, setClientArray] = useState([]);
  const [userList, setUserList] = useState([]);
  const [instruments, setInstruments] = useState([]);

  const [allAddress, setAllAddress] = useState([]);
  const [clientContactData, setClientContactData] = useState([]);

  const [ducRows, setDucRows] = useState([]);
  const [originalDucRows, setOriginalDucRows] = useState([]);
  const [ducRowsToDelete, setDucRowsToDelete] = useState([]);

  const updateInputObject = (key, value) => setInputStates((prev) => ({ ...prev, [key]: value }));

  const editAccess = localStorage.getItem("editAccess")?.split(",").map(Number);

  const fetchClients = () => {
    axiosWithToken
      .get(BASE_URL + "clients?_where=(status,eq,1)&_fields=id,companyName,uniCode,address,shippingAddress,contact,status&_sort=id")
      .then((res) =>
        setClientArray(
          (res.data || []).map((c) => ({
            id: c.id,
            label: `${c.id}, ${c.companyName}${
              c.uniCode ? ` (${c.uniCode})` : ""
            }`,
            companyName: c.companyName,
            address: c.address,
            shippingAddress: c.shippingAddress,
            contact: c.contact,
          }))
        )
      )
      .catch((err) => console.error("Failed to fetch clients", err));
  };

  const fetchSrfInstruments = () => {
    axiosWithToken
      .post(BASE_URL + "dynamic", { query: `SELECT id, instrumentName, status FROM instruments WHERE status = 1 ORDER BY id;`,})
      .then((res) => {
        const instruments = res.data || [];
        setInstruments(instruments);
      })
      .catch((err) => console.error("Failed to fetch instruments", err));
  };

  // Existing rows for this independent SRF (edit mode only)
  const fetchDucInstruments = () => {
    axiosWithToken
      .get(BASE_URL + `IndependentSrfInstruments?_where=(IndependentSrfId,eq,${params.id})`)
      .then((res) => {
        const rows = (res.data || []).map((r) => ({
          tempId: `row-${r.id}`,
          id: r.id,
          instrumentId: r.instrumentId ?? null,
          quantity: r.quantity ?? "",
          orderType: r.orderType ?? null,
          Location: r.Location ?? null,
          calibrationType: r.calibrationType ?? null,
          ducCondition: ConOfDucdOptions.find((opt) => opt.label === r.ducCondition)?.id ?? null,
          calFrequency: calFrequencyOptions.find((opt) => opt.label === r.calFrequency)?.id ?? null,
          OrderStatus: r.OrderStatus ?? null,
        }));
        setDucRows(rows);
        // keep a snapshot so we can diff on save and only PATCH changed rows
        setOriginalDucRows(rows);
      })
      .catch((err) =>
        console.error("Failed to fetch IndependentSrfInstruments", err)
      );
  };

  const fetchindependentSrfDetails = () => {
    axiosWithToken
      .get(BASE_URL + `independentSrf/${params.id}`)
      .then((res) => {
        const resultData = res.data?.[0];
        setInputStates({
          ...resultData,
          contactPersonDetails: resultData?.contactPerson
            ? typeof resultData.contactPerson === "string"
              ? JSON.parse(resultData.contactPerson)
              : resultData.contactPerson
            : null,
        });
      })
      .catch((err) => console.error("Failed to fetch independentSrf", err));
  };

  const fetchNextSrfNumber = async () => {
    try {
      const res = await axiosWithToken.post(BASE_URL + "dynamic", {
        query: `SELECT srfNumber FROM independentSrf WHERE srfNumber IS NOT NULL AND srfNumber != '' ORDER BY id DESC LIMIT 1`,
      });

      const lastSrfNumber = res.data?.[0]?.srfNumber;

      if (!lastSrfNumber) {
        updateInputObject("srfNumber", "SRF/1");
        return;
      }

      const parts = lastSrfNumber.split("/");

      if (parts.length >= 2) {
        const lastNumber = Number(parts[parts.length - 1]);

        if (!isNaN(lastNumber)) {
          parts[parts.length - 1] = lastNumber + 1;
          updateInputObject("srfNumber", parts.join("/"));
        }
      }
    } catch (error) {
      console.error("Failed to generate next SRF number", error);
    }
  };

  useEffect(() => {
    fetchClients();
    fetchSrfInstruments();
    if (isEdit) {
      fetchindependentSrfDetails();
      fetchDucInstruments();
    } else {
      fetchNextSrfNumber();
    }
  }, []);

  // address options and contact person options for that client - same
  // behaviour as the Edit SRF screen.
  useEffect(() => {
    const loadAddressAndContacts = async () => {
      const selectedClient = clientArray?.find((c) => c.id === inputStates.clientId);
      const addressIds = selectedClient?.address;
      const shippingAddressIds = selectedClient?.shippingAddress;

      const newAddressArray = await fetchAddresses(addressIds, shippingAddressIds);
      setAllAddress(newAddressArray || []);

      const contactData = selectedClient?.contact
        ? JSON.parse(selectedClient.contact)
        : [];
      setClientContactData(contactData);
    };

    if (inputStates.clientId) {
      loadAddressAndContacts();
    } else {
      setAllAddress([]);
      setClientContactData([]);
    }
  }, [inputStates.clientId, clientArray]);

  // the saved address id is already loaded from the record and the field is
  useEffect(() => {
    if (!isEdit && allAddress?.length === 1) {
      updateInputObject("address", allAddress[0]?.id ?? null);
    }
  }, [allAddress, isEdit]);

  // ---- row helpers ----

  const handleAddDucRow = () => {
    setDucRows((prev) => [
      ...prev,
      {
        tempId: makeTempId(), id: null, instrumentId: null, quantity: "", orderType: null, Location: null, calibrationType: null, ducCondition: null, calFrequency: null, OrderStatus: null,
      },
    ]);
  };

  const handleDucRowChange = (tempId, key, value) => {
    setDucRows((prev) =>
      prev.map((row) =>
        row.tempId === tempId ? { ...row, [key]: value } : row
      )
    );
  };

  // actually deleted from the server when Save/Update is clicked.
  const handleDeleteDucRow = (row) => {
    if (row.id) {
      setDucRowsToDelete((prev) => [...prev, row.id]);
    }
    setDucRows((prev) => prev.filter((r) => r.tempId !== row.tempId));
  };

  const validateDucRows = () => {
    for (let i = 0; i < ducRows.length; i++) {
      const row = ducRows[i];
      if (!row.instrumentId) {
        toast.error(`Row ${i + 1}: Please select an Instrument`);
        return false;
      }
      if (row.quantity === "" || row.quantity === null || Number(row.quantity) <= 0) {
        toast.error(`Row ${i + 1}: Please add an Quantity`);
        return false;
      }
    }
    return true;
  };

  // Saves row changes (add / update / delete) against IndependentSrfInstruments.
  const saveDucRows = async (independentSrfId) => {
    // 1) Delete rows
    if (ducRowsToDelete.length) {
      await Promise.all(
        ducRowsToDelete.map((id) =>
          axiosWithToken
            .delete(BASE_URL + `IndependentSrfInstruments/${id}`)
            .catch((err) =>
              console.error(`Failed to delete row ${id}`, err)
            )
        )
      );
    }

    // 2) New rows (never saved before) - sent together as a bulk insert
    const newRows = ducRows
      .filter((row) => !row.id)
      .map((row) => ({
        IndependentSrfId: independentSrfId,
        instrumentId: row.instrumentId,
        quantity: row.quantity,
        orderType: row.orderType,
        Location: row.Location,
        calibrationType: row.calibrationType,
        ducCondition: ConOfDucdOptions.find((opt) => opt.id == row.ducCondition)?.label || null,
        calFrequency: calFrequencyOptions.find((opt) => opt.id == row.calFrequency)?.label || null,
        OrderStatus: row.OrderStatus,
      }));

    if (newRows.length) {
      await axiosWithToken
        .post(BASE_URL + "IndependentSrfInstruments/bulk", newRows)
        .catch((err) => console.error("Failed to add DUC rows", err));
    }

    // 3) Existing rows - only PATCH the ones that actually changed
    const existingRows = ducRows.filter((row) => row.id);
    await Promise.all(
      existingRows.map((row) => {
        const original = originalDucRows.find((o) => o.id === row.id);
        const changed =
          !original ||
          original.instrumentId !== row.instrumentId ||
          String(original.quantity) !== String(row.quantity) ||
          original.orderType !== row.orderType ||
          original.Location !== row.Location ||
          original.calibrationType !== row.calibrationType ||
          original.ducCondition !== row.ducCondition ||
          original.calFrequency !== row.calFrequency ||
          original.OrderStatus !== row.OrderStatus;

        if (!changed) return Promise.resolve();

        return axiosWithToken
          .patch(BASE_URL + `IndependentSrfInstruments/${row.id}`, {
            instrumentId: row.instrumentId,
            quantity: row.quantity,
            orderType: row.orderType,
            Location: row.Location,
            calibrationType: row.calibrationType,
            ducCondition: ConOfDucdOptions.find((opt) => opt.id == row.ducCondition)?.label || null,
            calFrequency: calFrequencyOptions.find((opt) => opt.id == row.calFrequency)?.label || null,
            OrderStatus: row.OrderStatus,
          })
          .catch((err) =>
            console.error(`Failed to update DUC row ${row.id}`, err)
          );
      })
    );
  };

  const handleSubmit = async () => {
    const { clientId, srfNumber, entryDate, address, contactPersonDetails } =
      inputStates;

    if (!clientId) {
      toast.error("Please select Client Name.");
      return;
    }

    if (!address) {
      toast.error("Please select at least one Address.");
      return;
    }

    if (!srfNumber) {
      toast.error("Please enter Service Request No.");
      return;
    }

    if (!entryDate) {
      toast.error("Please select Entry Date.");
      return;
    }

    if (!validateDucRows()) return;

    const payload = {
      clientId,
      srfNumber,
      address: address ?? null,
      contactPerson: contactPersonDetails
        ? JSON.stringify(contactPersonDetails)
        : null,
      entryDate: entryDate ? moment(entryDate).format("YYYY-MM-DD") : null,
      party: inputStates.party ?? null,
      InvoiceNo: inputStates.InvoiceNo ?? null,
      teamMember: inputStates.teamMember ?? null,
      createdBy: localStorage.getItem("id"),
      status: 1,
    };

    try {
      if (isEdit) {
        await axiosWithToken.patch(
          BASE_URL + `independentSrf/${params.id}`,
          payload
        );
        await saveDucRows(params.id);
        toast.success("SRF updated successfully.");
        window.location.reload();
      } else {
        const res = await axiosWithToken.post(
          BASE_URL + "independentSrf",
          payload
        );
        const newSrfId = res?.data?.id ?? res?.data?.insertId;
        if (newSrfId) {
          await saveDucRows(newSrfId);
        }
        toast.success("SRF created successfully.");
        navigate("/independentSrfList");
      }
    } catch (err) {
      console.error("Failed to save independentSrf", err);
    }
  };

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" sx={{ float: "left" }}>
        {isEdit ? "Edit SRF" : "Create SRF"}
      </Typography>
      <br />

      <Grid container spacing={2}>
        {/* Client */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            options={clientArray}
            value={
              clientArray.find((o) => o.id == inputStates.clientId) || null
            }
            isOptionEqualToValue={(opt, val) => opt.id === val?.id}
            getOptionLabel={(opt) => opt.label || ""}
            onChange={(_, val) => {
              updateInputObject("clientId", val?.id ?? null);
              // Reset dependent fields when the client changes
              updateInputObject("address", null);
              updateInputObject("contactPersonDetails", null);
            }}
            renderInput={(params) => <TextField {...params} label="Client *" />}
            disabled={isEdit}
          />
        </Grid>

        {/* Address */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {allAddress?.length === 1 || isEdit ? (
            <TextField
              size="small"
              fullWidth
              label="Address *"
              value={
                allAddress?.length === 1
                  ? allAddress[0]?.address
                  : allAddress?.find((e) => e.id == inputStates.address)
                      ?.address || ""
              }
              disabled
            />
          ) : (
            <Autocomplete
              size="small"
              options={allAddress}
              value={
                allAddress?.find((e) => e.id == inputStates.address) || null
              }
              getOptionLabel={(opt) => opt?.address || ""}
              onChange={(_, val) => {
                // Dropdown selection -> save the selected address id
                updateInputObject("address", val?.id ?? null);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Address *" />
              )}
            />
          )}
        </Grid>

        {/* Contact Person */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            options={clientContactData}
            value={inputStates.contactPersonDetails || null}
            getOptionLabel={(opt) => opt?.contactPersonName || ""}
            isOptionEqualToValue={(opt, val) =>
              opt?.contactPersonName === val?.contactPersonName
            }
            onChange={(_, val) => {
              updateInputObject("contactPersonDetails", val || null);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Contact Person" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            size="small"
            fullWidth
            label="SRF No."
            value={inputStates.srfNumber || ""}
            multiline
            onChange={(e) => updateInputObject("srfNumber", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  inputProps: { readOnly: true },
                },
              }}
              inputFormat="dd/MM/yyyy"
              format="dd/MM/yyyy"
              label="Entry Date *"
              value={
                inputStates.entryDate ? new Date(inputStates.entryDate) : null
              }
              onChange={(val) => updateInputObject("entryDate", val)}
              //   maxDate={new Date()}
              //   minDate={editAccess?.includes(8) ? null : new Date()}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            size="small"
            fullWidth
            label="Invoice No."
            value={inputStates.InvoiceNo || ""}
            multiline
            onChange={(e) => updateInputObject("InvoiceNo", e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            options={teamMemberArray}
            value={
              teamMemberArray.find((opt) => opt.id == inputStates.teamMember) ||
              null
            }
            getOptionLabel={(opt) => opt.label || ""}
            onChange={(_, val) => {
              updateInputObject("teamMember", val?.id ?? null);
            }}
            renderInput={(params) => <TextField {...params} label="Team Member" />}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            size="small"
            fullWidth
            label="Party"
            value={inputStates.party || ""}
            multiline
            onChange={(e) => updateInputObject("party", e.target.value)}
          />
        </Grid>
      </Grid>

      <br />
      <hr />

      {/* DUC Instruments */}
      <Toolbar
        style={{
          padding: "0px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5><b>Instrument Details</b></h5>
        <Button
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddDucRow}
        >
          Add DUC
        </Button>
      </Toolbar>

      <div style={{ overflowX: "auto", width: "100%", maxHeight: "600px" }}>
      <ClassicTable>
        <Table size="small" sx={{minWidth: 1200, overflow: "scroll"}} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 220 }}>Instrument *</TableCell>
              <TableCell sx={{ width: 150 }}>Quantity *</TableCell>
              <TableCell sx={{ width: 160 }}>Order Type</TableCell>
              <TableCell sx={{ width: 160 }}>Location</TableCell>
              <TableCell sx={{ width: 180 }}>Calibration Type</TableCell>
              <TableCell sx={{ width: 170 }}>Condition</TableCell>
              <TableCell sx={{ width: 160 }}>Frequency</TableCell>
              <TableCell sx={{ width: 160 }}>Order Status</TableCell>
              <TableCell sx={{ width: 80 }} align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ducRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={9} style={{textAlign: "center"}}>
                  No DUC instruments added yet.
                </TableCell>
              </TableRow>
            )}
            {ducRows.map((row) => (
              <TableRow key={row.tempId}>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={instruments}
                    value={
                      instruments.find((i) => i.id === row.instrumentId) || null
                    }
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    getOptionLabel={(opt) =>
                      opt.id + " , " + opt?.instrumentName || ""
                    }
                    onChange={(_, val) =>
                      handleDucRowChange(
                        row.tempId,
                        "instrumentId",
                        val?.id ?? null
                      )
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Instrument *" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    type="number"
                    label="Quantity *"
                    value={row.quantity ?? ""}
                    onChange={(e) =>
                      handleDucRowChange(row.tempId, "quantity", e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={orserTYpeArray}
                    value={orserTYpeArray.find((opt) => opt.id == row.orderType) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) =>
                      handleDucRowChange(row.tempId, "orderType", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Order Type" />
                    )}
                  />
                </TableCell>

                <TableCell>
                  <Autocomplete
                    size="small"
                    options={locationOptions}
                    value={locationOptions.find((opt) => opt.id == row.Location) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) => handleDucRowChange(row.tempId, "Location", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Location" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={calTypeOption}
                    value={calTypeOption.find((opt) => opt.id == row.calibrationType) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) =>
                      handleDucRowChange(row.tempId, "calibrationType", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Calibration Type" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={ConOfDucdOptions}
                    value={ConOfDucdOptions.find((opt) => opt.id == row.ducCondition) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) =>
                      handleDucRowChange(row.tempId, "ducCondition", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Condition" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={calFrequencyOptions}
                    value={calFrequencyOptions.find((opt) => opt.id == row.calFrequency) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) =>
                      handleDucRowChange(row.tempId, "calFrequency", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Frequency" />
                    )}
                  />
                </TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    options={orderStatusOption}
                    value={orderStatusOption.find( (opt) => opt.id == row.OrderStatus) || null}
                    getOptionLabel={(opt) => opt?.label || ""}
                    isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                    onChange={(_, val) =>
                      handleDucRowChange(row.tempId, "OrderStatus", val?.id ?? null)
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Status" />
                    )}
                  />
                </TableCell>
                <TableCell align="center">
                  <Tooltip title="Remove">
                    <IconButton
                      size="small"
                      onClick={() => handleDeleteDucRow(row)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ClassicTable>
      </div>

      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "16px",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?"))
              window.history.back();
          }}
        >
          Cancel
        </Button>

        <Tooltip
          title={
            !(editAccess?.includes(0) || editAccess?.includes(1))
              ? "You don't have access"
              : ""
          }
        >
          <span>
            <Button
              variant="contained"
              size="small"
              disabled={!(editAccess?.includes(0) || editAccess?.includes(1))}
              onClick={handleSubmit}
            >
              {isEdit ? "Update" : "Save"}
            </Button>
          </span>
        </Tooltip>
      </Toolbar>
    </EditWrap>
  );
};

export default EditindependentSrf;
